export default {
  "m0": "Loading personal details…",
  "m1": "Please check the highlighted fields.",
  "m2": "Your sign-in email is linked to your secure member account and cannot be changed here. Please contact the club if it needs correcting.",
  "m3": "For emergency use by authorised club staff only.",
  "m4": "Add Family Member",
  "m5": "Search for an active member and send a relationship request.",
  "m6": "Selected member",
  "m7": "Current family",
  "m8": "No family members linked",
  "m9": "Add a member above to start a family connection request.",
  "m10": "Incoming requests",
  "m11": "Outgoing requests",
  "m12": "Manage the vehicles associated with your membership.",
  "m13": "This section will allow you to:",
  "m14": "Keep your levels up to date for better games, pairings and recommendations.",
  "m15": "Enter exact handicap",
  "m16": "We’ll use these levels to improve suitable games, pairings and recommendations.",
  "m17": "Set a level above to begin your sporting profile.",
  "m18": "Edit photo",
  "m19": "Live portrait",
  "m20": "Member #",
  "m21": "Your portrait is being prepared and will appear here automatically.",
  "m22": "Images are stored securely and synced with the club portal profile.",
  "m23": "Back to dining",
  "m24": "Privana dining",
  "m25": "Dining Reservations",
  "m26": "Thoughtful hospitality, reserved for you.",
  "m27": "Times shown in your club’s timezone",
  "m28": "Privana Dining",
  "m29": "Plan your visit",
  "m30": "Find a table",
  "m31": "Modifying",
  "m32": "Dining areas are loading…",
  "m33": "Dining reservations are not currently available.",
  "m34": "Preferred time · optional",
  "m35": "Any time",
  "m36": "Finding tables…",
  "m37": "Your table awaits",
  "m38": "Available Times",
  "m39": "Review your reservation",
  "m40": "Notes and special requests",
  "m41": "For severe allergies, please also contact the club directly so the dining team can assist you safely.",
  "m42": "Your plans",
  "m43": "Your next table is waiting.",
  "m44": "Choose a dining area and discover an available time.",
  "m45": "Make a Reservation",
  "m46": "Reservations are temporarily unavailable.",
  "m47": "Reservation History",
  "m48": "Past dining reservations will appear here.",
  "m49": "Cancellation policy",
  "m50": "Cancel reservation",
  "m51": "Cancel dining reservation?",
  "m52": "This releases your table and is subject to the club’s cancellation window. This action cannot be undone.",
  "m53": "Keep reservation",
  "m54": "LET’S PLAY",
  "m55": "What are we playing?",
  "m56": "We couldn’t load Let’s Play right now.",
  "m57": "No sports are currently available for Let’s Play at this club.",
  "m58": "Showing saved club sports.",
  "m59": "View history",
  "m60": "Club sport",
  "m61": "No active Golf courses are available.",
  "m62": "Golf · Game",
  "m63": "We couldn’t load the scoring tees. Check your connection or sign in again, then retry.",
  "m64": "Retry loading tees",
  "m65": "Tees",
  "m66": "This course isn’t ready for Let’s Play yet.",
  "m67": "The club needs to configure its scoring tees before a round can be started.",
  "m68": "Choose players",
  "m69": "Golf · Players",
  "m70": "Players from completed Let’s Play Golf rounds will appear here.",
  "m71": "Review round",
  "m72": "Continue round",
  "m73": "Couldn’t load your active rounds.",
  "m74": "holes completed",
  "m75": "Delete this round?",
  "m76": "We couldn’t delete this round. Try again.",
  "m77": "Activity unavailable"
}
